import { useHandlerQuery } from '../../useHandlerQuery';

export const useFlowDesignTemplates = () => {
  return useHandlerQuery((api) => api.flowDesigns().getFlowDesignTemplates(), {
    key: ['FLOW_DESIGN_TEMPLATES'],
    skipRefetch: true,
  });
};
